await themeComponent(theme.components['mc-element'], false);

class McDrawer extends McElement {
    constructor(){
        super();
    }

    connectedCallback(){
        this.drawers = this.querySelectorAll('mc-drawer');
    }

    postClose = () => {
        if(this.drawers){
            this.drawers.forEach(drawer => drawer.deactivate());
        }
    }
}

if(!window.customElements.get('mc-drawer')){
    window.customElements.define('mc-drawer', McDrawer);
}
window.McDrawer = McDrawer;